var parse = require('../parse/index.js');
/**
 * @category Weekday Helpers
 * @summary Is the given date Friday?
 *
 * @description
 * Is the given date Friday?
 *
 * @param {Date|String|Number} date - the date to check
 * @returns {Boolean} the date is Friday
 *
 * @example
 * // Is 26 September 2014 Friday?
 * var result = isFriday(new Date(2014, 8, 26))
 * //=> true
 */


function isFriday(dirtyDate) {
  return parse(dirtyDate).getDay() === 5;
}

module.exports = isFriday;